import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardContent, InputAdornment,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import { filter, isEmpty } from 'lodash';
import { FC, UIEvent, useEffect, useMemo, useRef, useState } from 'react';
import { API_SLUGS, GROUP_ROLES, SQL_INJECTION_PATTERNS } from '../../../constants';
import useFetch from '../../../hooks/http/useFetch';
import { Mail as MailIcon } from '../../../icons/mail';
import { axiosInstance } from '../../../services/axios';
import { IAlertState, useAlertState } from '../../../store/alertState';
import { IUserStoreState, useUserStore } from '../../../store/userState';
import MaterialReactTable from 'material-react-table';
import { useTableInfinity } from '../../../hooks/process/useTableInfinity';
import { Search } from '@mui/icons-material';
import SearchComponent from '../../common/search';
var format = require("string-template")

const limit = 20;
const disableInfiniteScroll = false;
export const InviteMembers: FC = () => {
  const setMessage = useAlertState(state =>
    //@ts-ignore
    state.setMessage)
  const [isSettingRole, setIsSettingRole] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const membersUrl = API_SLUGS.GET_ORGANIZATION_MEMBERS + `?limit={limit}&offset={offset}`;

  const membersUrlToUse = useMemo(() => membersUrl + `&search=${searchQuery}`, [searchQuery])

  const tableContainerRef = useRef<HTMLDivElement>(null);
  const { rows, fetchMoreOnBottomReached, isFetching, resetAndFetch } = useTableInfinity(
    "members",
    membersUrlToUse,
    tableContainerRef,
    limit
  );


  useEffect(() => {
    if (!disableInfiniteScroll) {
      fetchMoreOnBottomReached(tableContainerRef.current);
    }
  }, [fetchMoreOnBottomReached])



  const handleRoleChange = async (role: string, memberId: string) => {
    setIsSettingRole(true)
    try {
      await axiosInstance.patch(format(API_SLUGS.UPDATE_ORG_MEMBER, { id: memberId }), { role })
      resetAndFetch()
    } catch (error: any) {
    }
    setIsSettingRole(false)
  }

  const onSubmit = (data: string) => {

    const trimmedData = data.trim();
    for (const pattern of SQL_INJECTION_PATTERNS) {
      if (pattern.test(trimmedData)) {
        setMessage({ title: "Invalid search query. Please avoid special characters and SQL keywords.", type: "error" })
        return;
      }
    }
    setSearchQuery(trimmedData)
  }

  return <Card sx={{ textAlign: "left" }}>
    <SearchComponent onSubmit={onSubmit} />
    <Card sx={{ textAlign: "left", margin: "0px 15px" }}>
      <MaterialReactTable muiTablePaperProps={{
        elevation: 0
      }} enableGlobalFilter={false}
        columns={[
          {
            accessorKey: "email",
            header: "Member",
            Cell: (params: any) => {
              const member = params?.row?.original;
              return (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Avatar
                    alt={member.email}

                    sx={{
                      height: 40,
                      width: 40,
                      mr: 1
                    }}
                  >
                    {member.email[0]}
                  </Avatar>
                  {member?.email}
                </Box>
              )
            },
            size: 50
          },
          {
            accessorKey: "role",
            header: "Role",
            Cell: (params: any) => {
              const row = params?.row?.original;
              return (
                <Select
                  value={row.role}
                  disabled={isSettingRole}
                  onChange={(e) => handleRoleChange(e.target.value, row.id)}
                  sx={{ minWidth: "10em", maxWidth: "100%", textAlign: "left", flex: 1 }}
                >
                  {GROUP_ROLES.map((role) => (
                    <MenuItem key={role.key} value={role.key}>
                      {role.name}
                    </MenuItem>
                  ))}
                </Select>
              );
            },
            size: 50
          },
        ]}
        data={rows}
        initialState={{
          density: "compact",
          columnPinning: { left: ['id'] },

        }}
        enableColumnActions={false}
        enableSorting={false}
        enableStickyHeader



        enableTopToolbar={false}
        enablePagination={false}
        enableDensityToggle={false}
        enableColumnFilters={false}
        // enableRowVirtualization
        state={{
          showProgressBars: isFetching,
        }}
        muiTableContainerProps={{
          ref: tableContainerRef, //get access to the table container element
          sx: { maxHeight: "calc(80vh - 300px)" }, //give the table a max height
          onScroll: (
            event: UIEvent<HTMLDivElement> //add an event listener to the table container element
          ) => {
            if (!disableInfiniteScroll) {
              fetchMoreOnBottomReached(event.target as HTMLDivElement)
            }

          }
        }}
      />
    </Card>
  </Card>
};
